import { createAction, createSlice } from "@reduxjs/toolkit";
import { Popup, PopupQueryParams, initialPopupVal } from "../types";
import { RootState } from "store/store";

interface PopupState {
	popupList: Popup[];
	popupTotal: number;
	popupDetail: Popup;
}

const initialState: PopupState = {
	popupList: [],
	popupTotal: 0,
	popupDetail: initialPopupVal,
};

export const popupSlice = createSlice({
	name: "popup",
	initialState,
	reducers: {
		setListPopup: (state, action) => {
			state.popupList = action.payload.data;
			state.popupTotal = action.payload.total;
		},
		setDetailPopup: (state, action) => {
			state.popupDetail = action.payload.data;
		},
		deletePopup: (state, action) => {
			const { id } = action.payload;
			state.popupList = state.popupList.filter(el => el.id !== id);
			state.popupTotal = state.popupTotal - 1;
		},
		changeStatusPopup: (state, action) => {
			const { id, status } = action.payload;
			const index = state.popupList.findIndex(el => el.id === id);
			state.popupList[index].status = status;
		},
	},
});

export const selectPopupList = (state: RootState) => state.popup.popupList;
export const selectPopupTotal = (state: RootState) => state.popup.popupTotal;
export const selectPopupDetail = (state: RootState) => state.popup.popupDetail;

export const { setListPopup, setDetailPopup, deletePopup, changeStatusPopup } =
	popupSlice.actions;

export interface GetListPopupPayload {
	query: PopupQueryParams;
	callback?: () => void;
}
export const getListPopupAsync = createAction(
	"popup/getListPopupAsync",
	(payload: GetListPopupPayload) => ({
		payload: payload || {},
	}),
);

export interface UpdatePopupPayload {
	id: string | number;
	data: Popup;
	callback?: () => void;
}

export const updatePopupAsync = createAction(
	"popup/updatePopupAsync",
	(payload: UpdatePopupPayload) => ({
		payload: payload || {},
	}),
);

export interface GetDetailPopupPayload {
	id: string;
}

export const getDetailPopupAsync = createAction(
	"popup/getDetailPopupAsync",
	(payload: GetDetailPopupPayload) => ({
		payload,
	}),
);

export interface CreatePopupPayload {
	data: Popup;
	callback?: () => void;
}
export const createPopupAsync = createAction(
	"popup/createPopupAsync",
	(payload: CreatePopupPayload) => ({
		payload,
	}),
);

export interface DeletePopupPayload {
	id: number;
	callback?: () => void;
}
export const deletePopupAsync = createAction(
	"popup/deletePopupAsync",
	(payload: DeletePopupPayload) => ({
		payload,
	}),
);

export default popupSlice.reducer;
